<template>
  <transition name="slide-in">
    <div
      v-if="showPopup"
      class="global-popup"
      @click="closePopup()"
    >
      <div class="global-popup__content">
        <img
          :src="popup.imageUrl"
          :alt="popup.formTitle"
          class="no-tablet-adaptive"
        >
        <img
          :src="popup.imageUrlMobile || popup.imageUrl"
          :alt="popup.formTitle"
          class="tablet-adaptive"
        >

        <div
          class="global-popup__form"
          @click.stop
        >
          <h6 class="global-popup__title">
            {{ popup.formTitle }}
          </h6>

          <div class="global-popup__fields">
            <form-name-field
              ref="nameField"
              v-model="nameInput"
              class="form__input"
              placeholder="как вас зовут?"
            />

            <form-phone-field
              ref="phoneField"
              v-model="phoneInput"
              class="form__input form__input_phone"
              placeholder="ваш номер телефона"
              :errors-list="submitError"
              :error="validForm === false"
            />

            <form-email-field
              ref="emailField"
              v-model="emailInput"
              class="form__input"
              :submit-error="submitError"
              placeholder="ваша почта"
              @clearSubmitError="clearSubmitError"
            />
          </div>

          <button
            class="m-btn global-popup__btn"
            @click="submit"
          >
            {{ popup.buttonText }}
          </button>

          <!-- eslint-disable -->
          <p class="global-popup__law">
            нажимая на кнопку, вы соглашаетесь
            с&nbsp;<nuxt-link
            to="/privacy"
            target="_blank"
          >условиями обработки данных</nuxt-link>
            в&nbsp;соответствии
            с&nbsp;<nuxt-link
            to="/privacy"
            target="_blank"
          >политикой конфиденциальности</nuxt-link>
          </p>
          <!-- eslint-enable -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needName: true,
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
  needToSendComments: false,
  notCheckRefs: true,
});

export default {
  name: 'GlobalPopup',
  components: {
    FormNameField,
    FormEmailField,
    FormPhoneField,
  },
  mixins: [sendLeadMixin],

  data: () => ({
    showPopup: false,
    popup: null,
  }),
  computed: {
    ...mapState({
      wasShowedPopup: 'wasShowedGlobalPopup',
    }),
    titleToSend() {
      return this.popup.formTitle;
    },
    commentsToSend() {
      return '';
    },
    componentLandCode() {
      return this.popup?.landCode;
    },
  },

  mounted() {
    if (!this.wasShowedPopup) {
      this.getPopup();
      window.addEventListener('keydown', this.keyDownHnd);
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDownHnd);
  },

  methods: {
    ...mapActions(['setShowedGlobalPopup']),

    openPopup() {
      this.showPopup = true;
      this.setShowedGlobalPopup();
    },
    closePopup() {
      this.showPopup = false;
    },
    keyDownHnd(e) {
      if (e.key === 'Escape') {
        this.closePopup();
      }
    },

    async getPopup() {
      const response = await this.$api.getGlobalPopup();

      if (!response) return;

      this.popup = JSON.parse(response?.data?.payload || '{}');

      if (this.popup.showBy === 'time') {
        setTimeout(this.openPopup, (this.popup.showSeconds || 10) * 1000);
      }

      if (this.popup.showBy === 'scroll') {
        const openOnScroll = () => {
          if (window.scrollY > 500) {
            this.openPopup();
            window.removeEventListener('scroll', openOnScroll);
          }
        };

        window.addEventListener('scroll', openOnScroll);
      }
    },

    onSubmit() {
      this.closePopup();

      this.$notify({
        duration: 3000,
        text: 'Форма отправлена успешно!',
        type: 'success',
      });
    },
  },
};
</script>

<style scoped lang="scss">

.global-popup {
  position: fixed;
  inset: 0;
  z-index: 100;

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    backdrop-filter: blur(7px);
    background-color: rgba(0, 0, 0, 0.3);
  }

  &__content {
    display: flex;
    justify-content: center;
    gap: calc(var(--scale) * 20);
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
      margin-top: calc(var(--scale) * 12);
      align-items: flex-start;
    }

    @include media-down($size-mobile) {
      margin-block: calc(var(--scale) * 8);
      flex-direction: column;
      justify-content: flex-start;
      padding-block: calc(var(--scale) * 8);
      overflow-y: auto;
      max-height: 100dvh;
    }

    & > img {
      width: calc(var(--scale) * 560);
      aspect-ratio: 1;
      object-fit: cover;
      border-radius: calc(var(--scale) * 40);

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 366);
      }
    }
  }

  &__form {
    width: calc(var(--scale) * 366);
    padding: calc(var(--scale) * 20) calc(var(--scale) * 16);
    display: flex;
    flex-direction: column;
    border-radius: calc(var(--scale) * 32);
    background-color: #ffffff;
  }

  &__title {
    margin-bottom: calc(var(--scale) * 20);
    z-index: 2;
    font-weight: 500;
    font-size: calc(var(--scale) * 20);
    line-height: 110%;
    letter-spacing: -0.02em;
    text-align: center;
    color: #02120F;
  }

  &__fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: calc(var(--scale) * 8);

    .form__input {
      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: calc(var(--scale) * 68);
        background-color: #FFFFFF;
        border: 1px solid rgba(167, 171, 172, 0.5);
        border-radius: calc(var(--scale) * 24);

        font-weight: 500;
        font-size: calc(var(--scale) * 18);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 68);
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      ::v-deep .phone-field__input {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }
    }
  }

  &__law {
    margin-top: auto;

    text-align: center;
    font-weight: 400;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 14);
    }

    a {
      text-decoration: underline;
      color: #FF9C12;

      @media (hover: hover) {
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  &__btn {
    margin-top: calc(var(--scale) * 16);
    margin-bottom: calc(var(--scale) * 20);
    width: 100%;
    padding: calc(var(--scale) * 29) calc(var(--scale) * 10);
    border-radius: calc(var(--scale) * 24);
    transition: 200ms;
    background-color: #FF5319;

    font-weight: 500;
    font-size: calc(var(--scale) * 18);
    line-height: 120%;
    color: #FFFFFF;

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }
}

.slide-in-enter-active, .slide-in-leave-active {
  transition: transform 0.3s;
}

.slide-in-enter {
  transform: translateY(-100%);
}

.slide-in-leave-to {
  transform: translateY(100%);
}

</style>
